class AnchorJump extends window.HTMLElement {
  constructor() {
    super();
    this.init();
    this.handleShow();
  }

  init() {
    const navLinks = this.querySelectorAll(".anchor-jump-item");
    const sections = [];
    this.querySelectorAll(".anchor-jump-item").forEach((anchor) => {
      const id = anchor.getAttribute("href").substring(1);
      if (document.getElementById(id)) {
        sections.push(document.getElementById(id));
      }
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    });
    // 使用滚动事件替代 IntersectionObserver
    window.addEventListener("scroll", () => {
      let current = '';
      const windowHeight = window.innerHeight;
      const middleOfScreen = windowHeight / 2;
      
      sections.forEach((section) => {
        const sectionRect = section.getBoundingClientRect();
        if (sectionRect.top <= middleOfScreen && sectionRect.bottom >= middleOfScreen) {
          current = section.getAttribute("id");
        }
      });

      navLinks.forEach((link) => {
        link.classList.remove("active");
        if (link.getAttribute("href") === `#${current}`) {
          link.classList.add("active");
        }
      });
    });
  }
  handleShow() {
    const header = document.querySelector("#shopify-section-header-inline");
    const targetElement = this.querySelector(".anchor-jump-header");
    window.addEventListener("scroll", () => {
      const elementOffsetTop = this.getBoundingClientRect().top;
      if (elementOffsetTop < 0) {
        // 显示
        header.classList.add("section-header-hidden");
        targetElement.classList.add("anchor-jump-header-fixed");
      } else {
        // 隐藏
        header.classList.remove("section-header-hidden");
        targetElement.classList.remove("anchor-jump-header-fixed");
      }
    });
  }
}

window.customElements.define("anchor-jump", AnchorJump);
